import { assign, cond, get, stubTrue, tap } from 'lodash/fp';

import {
  getUid,
} from './getUid';

import {
  ensureUserAndGetIdToken,
} from './ensureUserAndGetIdToken';

import { log } from './log';

import axios from 'axios';

function postDelegatedRequest(method)
{
  return async function (data)
  {
    const handleResponse = tap(cond([
      [get('data.error'), response => this?.$emit?.('error', get('data.error')(response))],
      [stubTrue, response => this?.$emit?.('stop', response)],
    ]));

    this?.$emit?.('start');

    const uid = await getUid();
    const idToken = await ensureUserAndGetIdToken();

    const projectId = process.env.VUE_APP_PROJECT_ID;

    return await axios
    .post
    (
      `https://eatandtrack.herokuapp.com/${ method }`,
      assign
      (data)
      ({
        idToken,
        uid,
        projectId,
      }),
    )
    .then(handleResponse)
    .catch(log);
  };
}

export const foodAddFavorite = postDelegatedRequest('food.add_favorite');
export const foodCreateV2 = postDelegatedRequest('food.create.v2');
export const foodEntriesCopy = postDelegatedRequest('food_entries.copy');
export const foodEntriesCopySavedMeal = postDelegatedRequest('food_entries.copy_saved_meal');
export const foodEntriesGet = postDelegatedRequest('food_entries.get');
export const foodEntriesGetMonth = postDelegatedRequest('food_entries.get_month');
export const foodEntryCreate = postDelegatedRequest('food_entry.create');
export const foodEntryDelete = postDelegatedRequest('food_entry.delete');
export const foodEntryEdit = postDelegatedRequest('food_entry.edit');
export const foodFindIdForBarcode = postDelegatedRequest('food.find_id_for_barcode');
export const foodGetV2 = postDelegatedRequest('food.get.v2');
export const foodsAutocomplete = postDelegatedRequest('foods.autocomplete');
export const foodsGetFavorites = postDelegatedRequest('foods.get_favorites');
export const foodsGetMostEaten = postDelegatedRequest('foods.get_most_eaten');
export const foodsGetRecentlyEaten = postDelegatedRequest('foods.get_recently_eaten');
export const foodsSearch = postDelegatedRequest('foods.search');
export const profileGet = postDelegatedRequest('profile.get');
export const savedMealCreate = postDelegatedRequest('saved_meal.create');
export const savedMealDelete = postDelegatedRequest('saved_meal.delete');
export const savedMealItemAdd = postDelegatedRequest('saved_meal_item.add');
export const savedMealItemsGet = postDelegatedRequest('saved_meal_items.get');
export const savedMealsGet = postDelegatedRequest('saved_meals.get');
export const weightsGetMonth = postDelegatedRequest('weights.get_month');
export const weightUpdate = postDelegatedRequest('weight.update');